<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <h4>Exclude products based upon keywords</h4>
              <br />

              <!-- Search -->
              <ExcludedKeywordsFilter />

              <!-- Results -->
              <ExcludedKeywordsTable />

              <!-- Remove Keyword -->
              <RemoveKeywords />

              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import ExcludedKeywordsFilter from "./saveKeywords.vue";
import RemoveKeywords from "./removeKeywords.vue";
import ExcludedKeywordsTable from "./excludedKeywordsTable.vue";

export default {
  name: "excludedKeywords",
  components: {
    Header,
    Footer,
    DivvyAdminSidebar,
    ExcludedKeywordsFilter,
    RemoveKeywords,
    ExcludedKeywordsTable,
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "excludedKeywords",
        activeMenu: this.activeMenu ? this.activeMenu : "productandsuppliers",
      });
    },
  },
  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
